__webpack_require__.p = "https://uat.orders.affinity.io/";